var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import useWebp from './useWebp';
import styles from './ImageLoader.module.css';
export var IMAGE_FIT;
(function (IMAGE_FIT) {
    IMAGE_FIT["CONTAIN"] = "contain";
    IMAGE_FIT["COVER"] = "cover";
})(IMAGE_FIT || (IMAGE_FIT = {}));
const Image = (_a) => {
    var { title, className, isLoading, reserveHeight, hideImage, fit, useLazyLoading, src, srcSet, sizes, webpFallbackFormat = 'jpg', handleImageLoaded, handleImageError, imageRef } = _a, rest = __rest(_a, ["title", "className", "isLoading", "reserveHeight", "hideImage", "fit", "useLazyLoading", "src", "srcSet", "sizes", "webpFallbackFormat", "handleImageLoaded", "handleImageError", "imageRef"]);
    const { isWebp, srcFallback, srcSetFallback } = useWebp({
        src,
        srcSet,
        webpFallbackFormat
    });
    const imageProps = {
        className: cx(className, {
            [styles.imageReserveHeight]: reserveHeight,
            [styles.hideImage]: hideImage,
            [styles.imageCover]: fit === IMAGE_FIT.COVER,
            [styles.imageContain]: fit === IMAGE_FIT.CONTAIN,
            [styles.imageLazyLoad]: useLazyLoading,
            [styles.imageIsLoading]: isLoading
        }),
        onLoad: handleImageLoaded,
        onError: handleImageError,
        ref: imageRef
    };
    if (isWebp) {
        return (React.createElement("picture", null,
            React.createElement("source", { "data-srcset": (useLazyLoading && (srcSet || src)) || undefined, srcSet: (!useLazyLoading && (srcSet || src)) || undefined, sizes: sizes, media: "all", type: "image/webp" }),
            React.createElement("img", Object.assign({ crossOrigin: "anonymous", alt: title, src: (!useLazyLoading && srcFallback) || undefined, "data-src": (useLazyLoading && srcFallback) || undefined, srcSet: (!useLazyLoading && srcSetFallback) || undefined, "data-srcset": (useLazyLoading && srcSetFallback) || undefined, sizes: sizes }, imageProps, rest))));
    }
    return (React.createElement("img", Object.assign({ crossOrigin: "anonymous", alt: title, src: (!useLazyLoading && src) || undefined, "data-src": (useLazyLoading && src) || undefined, srcSet: (!useLazyLoading && srcSet) || undefined, "data-srcset": (useLazyLoading && srcSet) || undefined, sizes: sizes }, imageProps, rest)));
};
export default Image;
//# sourceMappingURL=Image.js.map